import { Movement } from 'pando-constants';

import HandleResponses from '@common/utils/handleResponses';
import axios from '@/axios';
import faker from './faker';

const fake = false;
const actions = {
  async list({ commit }, filter) {
    try {
      commit('SET_PAYMENTS_LOADING', true);
      const result = await axios('/payment', { params: filter });
      commit('SET_PAYMENTS', result.data);
      commit('SET_FILTER', filter);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_PAYMENTS_LOADING', false);
    }
  },
  async save(_, data) {
    try {
      // commit('SET_PAYMENTS_LOADING', true);
      const result = await axios.put('/payment', { data });
      if (result.newPayload) {
        const newPayload = result.newPayload.payments;
        while (newPayload.length) {
          const payments = newPayload.splice(0, 10);
          // eslint-disable-next-line no-await-in-loop
          await axios.patch('/v2/transporter/multiPayments/', { data: { payments } });
        }
      }
      // commit('SET_PAYMENTS', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      // commit('SET_PAYMENTS_LOADING', false);
    }
  },
  async updatephysical(_, data) {
    try {
      // commit('SET_PAYMENTS_LOADING', true);
      const result = await axios.put(`/payment/${data.id}/document`, { data: {
        received: data.received,
      } });
      // commit('SET_PAYMENTS', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      // commit('SET_PAYMENTS_LOADING', false);
    }
  },
  async invoicelist({ commit }, filter) {
    try {
      commit('SET_INVOICE_LOADING', true);
      if (fake) {
        const result = await new Promise(resolve => setTimeout(() => resolve(faker.invoicelist), 500));
        commit('SET_INVOICE', result.data);
        return result.data;
      }
      const result = await axios('/invoice', { params: filter });
      /* result.data.map((i)=>{
          i.revision = {
            type: 1,
            number: '345635',
            value: '5600',
          };
          return i;
        }); */
      commit('SET_INVOICE', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_INVOICE_LOADING', false);
    }
  },

  async showinvoice({ commit }, filter) {
    try {
      // commit('SET_INVOICE_LOADING', true);
      if (fake) {
        const result = await new Promise(resolve => setTimeout(() => resolve(faker.invoicedetail), 500));
        // commit('SET_INVOICE', result.data);
        return result.data;
      }
      const result = await axios(`/invoice/${filter.id}`);
      /*
        result.data.revision = {
          type: 1,
          number: '345635',
          value: '5600',
        }; */
      // commit('SET_INVOICE', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      // commit('SET_INVOICE_LOADING', false);
    }
  },
  async getIndentDetails({ commit }, data) {
    try {
      const result = await axios.post('payment/indent-details', { data: { ids: data.ids } });
      if (result && result.data) {
        commit('setPayment', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      // commit('SET_INVOICE_LOADING', false);
    }
  },
  async createinvoice(_, data) {
    try {
      const v1InvoiceRequest = data.v1InvoiceRequest;
      const v2InvoiceRequest = data.v2InvoiceRequest;
      const result = await axios.post('/invoice', { data: v1InvoiceRequest });
      if (data.isPayV1V2Enabled && v2InvoiceRequest &&
        v2InvoiceRequest.movement === Movement.PRIMARY) {
        axios.post('/v2/transporter/invoice', { data: v2InvoiceRequest });
      }
      return result.data;
    } catch (err) {
      return err;
    }
  },
  async reSubmit(_, invoiceId) {
    try {
      const result = await axios.put(`/invoice/${invoiceId}/resubmit`, { });
      return result;
    } catch (err) {
      return err;
    }
  },

  async createnote(_, data) {
    try {
      const result = await axios.post(`/invoice/${data.invoiceId}/revision`, { data: {
        client_id: data.clientId,
        number: data.number,
        value: data.value,
      } });
      return data;
    } catch (err) {
      return err;
    }
  },
  async addComment({ commit }, { data }) {
    try {
      commit('commentLoading', true);
      commit('setComments', []);
      const result = await axios.post('/conversation', { data });
      if (result && result.data) {
        commit('setComments', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('commentLoading', false);
    }
  },

  async comments({ commit }, { data }) {
    try {
      commit('setComments', []);
      const result = await axios(`conversation/${data.id}/`, { params: { section: data.section, client_id: data.client_id } });
      if (result && result.data) {
        commit('setComments', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async exportInvoice(_, filter) {
    try {
      const result = await axios({ url: '/invoice/export',
        method: 'POST',
        responseType: 'blob',
        data: filter });
      return result;
    } catch (error) {
      return { error };
    }
  },
  async uploadDocument({ commit }, data) {
    try {
      commit('setUploading', true);
      const result = await axios.post('/attachment', data, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result.data;
    } catch (error) {
      commit('setUploading', false);
      return error;
    } finally {
      commit('setUploading', false);
    }
  },
  async addAttachment(_, { data }) {
    try {
      const result = await axios.put(`/payment/${data.paymentId}/add_attachment`, { data: { attachment_id: data.attachment_id } });
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async filter({ commit }, params) {
    try {
      commit('SET_EMPTY_PAGINATE', false);
      commit('SET_PAYMENTS', []);
      commit('SET_ALL_ORDERS_LOADING', true);
      const result = await axios('/payment', { params });
      commit('SET_FILTER', params);
      commit('SET_CLIENT', params.client_id);
      if (result.data) {
        commit('SET_PAYMENTS', result.data);
      }
      commit('SET_COUNT', result.meta);
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ALL_ORDERS_LOADING', false);
    }
  },
  async filterInvoice({ commit }, filter) {
    try {
      commit('SET_EMPTY_PAGINATE', false);
      commit('SET_PAGINATION_STATUS', false);
      commit('SET_INVOICE', []);
      commit('SET_INVOICE_LOADING', true);
      const result = await axios('/invoice', { params: filter });
      commit('SET_INVOICE', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_INVOICE_LOADING', false);
    }
  },
  async paginate({ commit }, { params }) {
    try {
      commit('SET_PAGINATION_STATUS', true);
      const result = await axios('/payment', { params });
      commit('SET_PAGINATED_DATA', result.data);
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_PAGINATION_STATUS', false);
    }
  },
  async paginateInvoice({ commit }, { params }) {
    try {
      commit('SET_PAGINATION_STATUS', true);
      const result = await axios('/invoice', { params });
      commit('SET_PAGINATED_INVOICE_DATA', result.data);
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_PAGINATION_STATUS', false);
    }
  },
  async removeAttachment(_, { data }) {
    try {
      const result = await axios.delete(`order/${data.indent_id}/consignee/${data.consignee_id}/lr/${data.file_id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async saveLorryReceipt(_, { orderId, data }) {
    try {
      const result = await axios.put(`/order/${orderId}/lorry_receipt`, { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getLrAttachments(_, { orderId }) {
    try {
      const result = await axios.get(`/order/${orderId}/lr`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
